import React from 'react'
import PropTypes from 'prop-types'
import { withSize } from '../../components/utils'
import { Content } from './DefaultLayout.styles'
import TopBar from '../../components/NavBar/TopBar'
import SideBar from '../../components/NavBar/SideBar'

const DefaultLayout = ({
    children,
    estates,
    flashMessages,
    fullscreen,
    history,
    isIframe,
    isMobile,
    messages,
    onClickChangeLanguage,
    onClickConfigureDevice,
    onClickEstate,
    onClickLogout,
    onClickNavigateLog,
    onClickNavigateOperationsHub,
    onClickNavigateReports,
    onDismiss,
    onDismissAll,
    onDismissFlash,
    pathname,
    selectedEstate,
    username,
}) => {
    return (
        <>
            {!fullscreen && (
                <>
                    <TopBar
                        estates={estates}
                        flashMessages={flashMessages}
                        fullscreen={fullscreen}
                        history={history}
                        isIframe={isIframe}
                        isMobile={isMobile}
                        isDesktop={!isMobile}
                        messages={messages}
                        onClickChangeLanguage={onClickChangeLanguage}
                        onClickConfigureDevice={onClickConfigureDevice}
                        onClickEstate={onClickEstate}
                        onClickLogout={onClickLogout}
                        onClickNavigateLog={onClickNavigateLog}
                        onClickNavigateOperationsHub={onClickNavigateOperationsHub}
                        onClickNavigateReports={onClickNavigateReports}
                        pathname={pathname}
                        selectedEstate={selectedEstate}
                        username={username}
                    />
                    <SideBar
                        flashMessages={flashMessages}
                        fullscreen={fullscreen}
                        messages={messages}
                        onDismiss={onDismiss}
                        onDismissAll={onDismissAll}
                        onDismissFlash={onDismissFlash}
                    />
                </>
            )}
            <Content fullscreen={fullscreen}>{children}</Content>
        </>
    )
}

DefaultLayout.propTypes = {
    ...withSize.propTypes,
    children: PropTypes.node.isRequired,
    estates: PropTypes.arrayOf(PropTypes.shape({})),
    flashMessages: PropTypes.arrayOf(PropTypes.shape({})),
    fullscreen: PropTypes.bool,
    history: PropTypes.shape({}).isRequired,
    isIframe: PropTypes.bool,
    isMobile: PropTypes.bool,
    messages: PropTypes.arrayOf(PropTypes.shape({})),
    onClickChangeLanguage: PropTypes.func,
    onClickConfigureDevice: PropTypes.func,
    onClickEstate: PropTypes.func,
    onClickLogout: PropTypes.func,
    onClickNavigateLog: PropTypes.func,
    onClickNavigateOperationsHub: PropTypes.func,
    onClickNavigateReports: PropTypes.func,
    onDismiss: PropTypes.func.isRequired,
    onDismissAll: PropTypes.func.isRequired,
    onDismissFlash: PropTypes.func.isRequired,
    pathname: PropTypes.string.isRequired,
    selectedEstate: PropTypes.string,
    username: PropTypes.string,
}

DefaultLayout.defaultProps = {
    estates: [],
    flashMessages: [],
    fullscreen: false,
    isIframe: false,
    isMobile: false,
    messages: [],
    onClickChangeLanguage: () => null,
    onClickConfigureDevice: () => null,
    onClickEstate: () => null,
    onClickLogout: () => null,
    onClickNavigateLog: () => null,
    onClickNavigateOperationsHub: () => null,
    onClickNavigateReports: () => null,
    selectedEstate: null,
    username: null,
}

export default withSize(DefaultLayout)
